export default "__VITE_ASSET__6Sc9cIYk__"